var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconEmailPillAvatar = function SvgIconEmailPillAvatar(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.631 67.981",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "icon-email-pill-avatar_svg__a",
    width: 1.118,
    height: 1.158,
    x: -0.059,
    y: -0.079,
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0.473684211 0 0 0 0 1 0 0 0 0.241258741 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#368bd6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    filter: "url(#icon-email-pill-avatar_svg__a)",
    transform: "translate(-1493.716 -795.144)scale(3.40907)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(441.5 237.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.286,
    cy: 5.714,
    r: 2.286
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.571 3.429v2.857a1.714 1.714 0 1 0 3.429 0v-.572a5.714 5.714 0 1 0-2.24 4.537"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconEmailPillAvatar);
export { ForwardRef as Icon };
export default "img/icon-email-pill-avatar.a6d2e88.svg";